import FormattedMessage from 'I18n/components/FormattedMessage';
import { isEmpty } from '../../../utils/transformValueUtils';
import FieldWithLabelAndValue from './atomic/FieldWithLabelAndValue';
import { EMPTY_VALUE } from '../../../constants/emptyValues';
import { jsx as _jsx } from "react/jsx-runtime";
const BilledCustomerName = ({
  value
}) => {
  const fullName = isEmpty(value) ? EMPTY_VALUE : value;
  return /*#__PURE__*/_jsx(FieldWithLabelAndValue, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "highlightCard.propertyLabels.customerName"
    }),
    value: fullName
  });
};
export default BilledCustomerName;